var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsNotEmpty, IsString, ValidateNested } from 'class-validator';
export class AuthorizeSubscriberRequest {
    tenantId;
    publicKey;
    subject;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthorizeSubscriberRequest.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthorizeSubscriberRequest.prototype, "publicKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthorizeSubscriberRequest.prototype, "subject", void 0);
export class AuthorizeSubscriberResponse {
    token;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthorizeSubscriberResponse.prototype, "token", void 0);
export class SubscribeRequest {
    tenantId;
    publicKey;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscribeRequest.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscribeRequest.prototype, "publicKey", void 0);
export class SubscribeResponse {
    publicKey;
    gateway;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscribeResponse.prototype, "publicKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscribeResponse.prototype, "gateway", void 0);
export class GetSubscribersRequest {
    tenantId;
    subject;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetSubscribersRequest.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetSubscribersRequest.prototype, "subject", void 0);
export class SubscriberMeta {
    publicKey;
    gateway;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscriberMeta.prototype, "publicKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SubscriberMeta.prototype, "gateway", void 0);
export class GetSubscribersResponse {
    subscribers;
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], GetSubscribersResponse.prototype, "subscribers", void 0);
// Encrypted represents a byte buffer that has been encrypted with aes-256-gcm,
// which is used because it's fast and provides authenticity.
// https://en.wikipedia.org/wiki/Galois/Counter_Mode
export class EncryptedModel {
    iv;
    ciphertext;
    constructor(init) {
        Object.assign(this, init);
    }
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EncryptedModel.prototype, "iv", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EncryptedModel.prototype, "ciphertext", void 0);
export class AuthenticateSubscriberRequest extends EncryptedModel {
    static type = 'AuthenticateSubscriberRequest';
    type = AuthenticateSubscriberRequest.type;
    tenantId;
    publicKey;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthenticateSubscriberRequest.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthenticateSubscriberRequest.prototype, "publicKey", void 0);
export class AuthenticatePublisherRequest {
    static type = 'AuthenticatePublisherRequest';
    type = AuthenticatePublisherRequest.type;
    tenantId;
    publicKey;
    constructor(init) {
        Object.assign(this, init);
    }
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthenticatePublisherRequest.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AuthenticatePublisherRequest.prototype, "publicKey", void 0);
export class PubSubMessage extends EncryptedModel {
    static type = 'PubSubMessage';
    type = PubSubMessage.type;
    tenantId;
    publisherPublicKey;
    subscriberPublicKey;
    subject;
    signature;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PubSubMessage.prototype, "tenantId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PubSubMessage.prototype, "publisherPublicKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PubSubMessage.prototype, "subscriberPublicKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PubSubMessage.prototype, "subject", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PubSubMessage.prototype, "signature", void 0);
//# sourceMappingURL=types.js.map